import { Base } from './base.model';

export class AdjustmentType extends Base {
  public shortName: string;
}
